import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default (withEmptyOption = false) => {
  const { t, i18n } = useTranslation('personal_pronouns');
  const pronouns = i18n.store.data[i18n.language]?.personal_pronouns;

  if (withEmptyOption) pronouns.empty_option = '';

  const personalPronounList = useMemo(
    () =>
      Object.keys(pronouns).map((key, index) => {
        const isBlankOption = key === 'empty_option';
        const label = !isBlankOption ? t(key) : '';
        // Set id to 99, so it will always be the last option in list
        const id = isBlankOption ? 99 : index;
        return { id, key, label, isBlankOption };
      }),
    [i18n.language],
  );

  return { data: personalPronounList };
};
